// Australian suburbs organized by state/territory
// Curated list of major suburbs. When a suburb is not found here, searchSuburbsAsync
// falls back to Matthew Proctor's postcode dataset (fetched once per session, cached in memory).
// Source: https://github.com/matthewproctor/australianpostcodes
export const AUSTRALIAN_SUBURBS = [
    // New South Wales (NSW)
    { name: "Sydney", state: "NSW", postcode: "2000" },
    { name: "Parramatta", state: "NSW", postcode: "2150" },
    { name: "Liverpool", state: "NSW", postcode: "2170" },
    { name: "Blacktown", state: "NSW", postcode: "2148" },
    { name: "Newcastle", state: "NSW", postcode: "2300" },
    { name: "Wollongong", state: "NSW", postcode: "2500" },
    { name: "Penrith", state: "NSW", postcode: "2750" },
    { name: "Campbelltown", state: "NSW", postcode: "2560" },
    { name: "Bankstown", state: "NSW", postcode: "2200" },
    { name: "Chatswood", state: "NSW", postcode: "2067" },
    { name: "Bondi", state: "NSW", postcode: "2026" },
    { name: "Manly", state: "NSW", postcode: "2095" },
    { name: "Cronulla", state: "NSW", postcode: "2230" },
    { name: "Ryde", state: "NSW", postcode: "2112" },
    { name: "Hornsby", state: "NSW", postcode: "2077" },
    { name: "Sutherland", state: "NSW", postcode: "2232" },
    { name: "Burwood", state: "NSW", postcode: "2134" },
    { name: "Strathfield", state: "NSW", postcode: "2135" },
    { name: "Auburn", state: "NSW", postcode: "2144" },
    { name: "Hurstville", state: "NSW", postcode: "2220" },
    { name: "Castle Hill", state: "NSW", postcode: "2154" },
    { name: "Epping", state: "NSW", postcode: "2121" },
    { name: "North Sydney", state: "NSW", postcode: "2060" },
    { name: "Mosman", state: "NSW", postcode: "2088" },
    { name: "Surry Hills", state: "NSW", postcode: "2010" },
    { name: "Newtown", state: "NSW", postcode: "2042" },
    { name: "Leichhardt", state: "NSW", postcode: "2040" },
    { name: "Balmain", state: "NSW", postcode: "2041" },
    { name: "Randwick", state: "NSW", postcode: "2031" },
    { name: "Coogee", state: "NSW", postcode: "2034" },
    { name: "Maroubra", state: "NSW", postcode: "2035" },
    { name: "Woollahra", state: "NSW", postcode: "2025" },
    { name: "Paddington", state: "NSW", postcode: "2021" },
    { name: "Darlinghurst", state: "NSW", postcode: "2010" },
    { name: "Redfern", state: "NSW", postcode: "2016" },
    { name: "Pyrmont", state: "NSW", postcode: "2009" },
    { name: "Glebe", state: "NSW", postcode: "2037" },
    { name: "Annandale", state: "NSW", postcode: "2038" },
    { name: "Dulwich Hill", state: "NSW", postcode: "2203" },
    { name: "Marrickville", state: "NSW", postcode: "2204" },
    { name: "Ashfield", state: "NSW", postcode: "2131" },
    { name: "Concord", state: "NSW", postcode: "2137" },
    { name: "Drummoyne", state: "NSW", postcode: "2047" },
    { name: "Five Dock", state: "NSW", postcode: "2046" },
    { name: "Canada Bay", state: "NSW", postcode: "2046" },
    { name: "Rhodes", state: "NSW", postcode: "2138" },
    { name: "Meadowbank", state: "NSW", postcode: "2114" },
    { name: "Gladesville", state: "NSW", postcode: "2111" },
    { name: "Hunters Hill", state: "NSW", postcode: "2110" },
    { name: "Lane Cove", state: "NSW", postcode: "2066" },
    { name: "Willoughby", state: "NSW", postcode: "2068" },
    { name: "Artarmon", state: "NSW", postcode: "2064" },
    { name: "Crows Nest", state: "NSW", postcode: "2065" },
    { name: "St Leonards", state: "NSW", postcode: "2065" },
    { name: "Neutral Bay", state: "NSW", postcode: "2089" },
    { name: "Cremorne", state: "NSW", postcode: "2090" },
    { name: "Dee Why", state: "NSW", postcode: "2099" },
    { name: "Brookvale", state: "NSW", postcode: "2100" },
    { name: "Mona Vale", state: "NSW", postcode: "2103" },
    { name: "Avalon", state: "NSW", postcode: "2107" },
    { name: "Narrabeen", state: "NSW", postcode: "2101" },
    { name: "Collaroy", state: "NSW", postcode: "2097" },
    { name: "Freshwater", state: "NSW", postcode: "2096" },
    { name: "Balgowlah", state: "NSW", postcode: "2093" },
    { name: "Fairlight", state: "NSW", postcode: "2094" },
    { name: "Allambie Heights", state: "NSW", postcode: "2100" },
    { name: "Frenchs Forest", state: "NSW", postcode: "2086" },
    { name: "Belrose", state: "NSW", postcode: "2085" },
    { name: "Davidson", state: "NSW", postcode: "2085" },
    { name: "Lindfield", state: "NSW", postcode: "2070" },
    { name: "Killara", state: "NSW", postcode: "2071" },
    { name: "Gordon", state: "NSW", postcode: "2072" },
    { name: "Pymble", state: "NSW", postcode: "2073" },
    { name: "Turramurra", state: "NSW", postcode: "2074" },
    { name: "Wahroonga", state: "NSW", postcode: "2076" },
    { name: "Normanhurst", state: "NSW", postcode: "2076" },
    { name: "Thornleigh", state: "NSW", postcode: "2120" },
    { name: "Pennant Hills", state: "NSW", postcode: "2120" },
    { name: "Beecroft", state: "NSW", postcode: "2119" },
    { name: "Cherrybrook", state: "NSW", postcode: "2126" },
    { name: "West Pennant Hills", state: "NSW", postcode: "2125" },
    { name: "Baulkham Hills", state: "NSW", postcode: "2153" },
    { name: "Kellyville", state: "NSW", postcode: "2155" },
    { name: "Rouse Hill", state: "NSW", postcode: "2155" },
    { name: "The Ponds", state: "NSW", postcode: "2769" },
    { name: "Schofields", state: "NSW", postcode: "2762" },
    { name: "Riverstone", state: "NSW", postcode: "2765" },
    { name: "Windsor", state: "NSW", postcode: "2756" },
    { name: "Richmond", state: "NSW", postcode: "2753" },
    { name: "St Marys", state: "NSW", postcode: "2760" },
    { name: "Mount Druitt", state: "NSW", postcode: "2770" },
    { name: "Rooty Hill", state: "NSW", postcode: "2766" },
    { name: "Doonside", state: "NSW", postcode: "2767" },
    { name: "Seven Hills", state: "NSW", postcode: "2147" },
    { name: "Toongabbie", state: "NSW", postcode: "2146" },
    { name: "Wentworthville", state: "NSW", postcode: "2145" },
    { name: "Westmead", state: "NSW", postcode: "2145" },
    { name: "Merrylands", state: "NSW", postcode: "2160" },
    { name: "Guildford", state: "NSW", postcode: "2161" },
    { name: "Fairfield", state: "NSW", postcode: "2165" },
    { name: "Cabramatta", state: "NSW", postcode: "2166" },
    { name: "Canley Vale", state: "NSW", postcode: "2166" },
    { name: "Bossley Park", state: "NSW", postcode: "2176" },
    { name: "Wetherill Park", state: "NSW", postcode: "2164" },
    { name: "Smithfield", state: "NSW", postcode: "2164" },
    { name: "Bonnyrigg", state: "NSW", postcode: "2177" },
    { name: "Hoxton Park", state: "NSW", postcode: "2171" },
    { name: "Prestons", state: "NSW", postcode: "2170" },
    { name: "Casula", state: "NSW", postcode: "2170" },
    { name: "Moorebank", state: "NSW", postcode: "2170" },
    { name: "Chipping Norton", state: "NSW", postcode: "2170" },
    { name: "Green Valley", state: "NSW", postcode: "2168" },
    { name: "Busby", state: "NSW", postcode: "2168" },
    { name: "Miller", state: "NSW", postcode: "2168" },
    { name: "Cartwright", state: "NSW", postcode: "2168" },
    { name: "Sadleir", state: "NSW", postcode: "2168" },
    { name: "Heckenberg", state: "NSW", postcode: "2168" },
    { name: "Leppington", state: "NSW", postcode: "2179" },
    { name: "Ingleburn", state: "NSW", postcode: "2565" },
    { name: "Macquarie Fields", state: "NSW", postcode: "2564" },
    { name: "Glenfield", state: "NSW", postcode: "2167" },
    { name: "Caringbah", state: "NSW", postcode: "2229" },
    { name: "Miranda", state: "NSW", postcode: "2228" },
    { name: "Gymea", state: "NSW", postcode: "2227" },
    { name: "Kirrawee", state: "NSW", postcode: "2232" },
    { name: "Jannali", state: "NSW", postcode: "2226" },
    { name: "Como", state: "NSW", postcode: "2226" },
    { name: "Oyster Bay", state: "NSW", postcode: "2225" },
    { name: "Sylvania", state: "NSW", postcode: "2224" },
    { name: "Menai", state: "NSW", postcode: "2234" },
    { name: "Bangor", state: "NSW", postcode: "2234" },
    { name: "Engadine", state: "NSW", postcode: "2233" },
    { name: "Heathcote", state: "NSW", postcode: "2233" },
    { name: "Waterfall", state: "NSW", postcode: "2233" },
    { name: "Kogarah", state: "NSW", postcode: "2217" },
    { name: "Carlton", state: "NSW", postcode: "2218" },
    { name: "Allawah", state: "NSW", postcode: "2218" },
    { name: "Beverley Park", state: "NSW", postcode: "2217" },
    { name: "Oatley", state: "NSW", postcode: "2223" },
    { name: "Mortdale", state: "NSW", postcode: "2223" },
    { name: "Penshurst", state: "NSW", postcode: "2222" },
    { name: "Peakhurst", state: "NSW", postcode: "2210" },
    { name: "Lugarno", state: "NSW", postcode: "2210" },
    { name: "Riverwood", state: "NSW", postcode: "2210" },
    { name: "Narwee", state: "NSW", postcode: "2209" },
    { name: "Beverly Hills", state: "NSW", postcode: "2209" },
    { name: "Kingsgrove", state: "NSW", postcode: "2208" },
    { name: "Bexley", state: "NSW", postcode: "2207" },
    { name: "Rockdale", state: "NSW", postcode: "2216" },
    { name: "Arncliffe", state: "NSW", postcode: "2205" },
    { name: "Wolli Creek", state: "NSW", postcode: "2205" },
    { name: "Mascot", state: "NSW", postcode: "2020" },
    { name: "Alexandria", state: "NSW", postcode: "2015" },
    { name: "Waterloo", state: "NSW", postcode: "2017" },
    { name: "Zetland", state: "NSW", postcode: "2017" },
    { name: "Rosebery", state: "NSW", postcode: "2018" },
    { name: "Botany", state: "NSW", postcode: "2019" },
    { name: "Kingsford", state: "NSW", postcode: "2032" },
    { name: "Kensington", state: "NSW", postcode: "2033" },
    { name: "Eastgardens", state: "NSW", postcode: "2036" },
    { name: "Pagewood", state: "NSW", postcode: "2035" },
    { name: "Malabar", state: "NSW", postcode: "2036" },
    { name: "La Perouse", state: "NSW", postcode: "2036" },
    { name: "Ramsgate", state: "NSW", postcode: "2217" },
    { name: "Sans Souci", state: "NSW", postcode: "2219" },
    { name: "Dolls Point", state: "NSW", postcode: "2219" },
    // Victoria (VIC)
    { name: "Melbourne", state: "VIC", postcode: "3000" },
    { name: "Geelong", state: "VIC", postcode: "3220" },
    { name: "Ballarat", state: "VIC", postcode: "3350" },
    { name: "Bendigo", state: "VIC", postcode: "3550" },
    { name: "Shepparton", state: "VIC", postcode: "3630" },
    { name: "Mildura", state: "VIC", postcode: "3500" },
    { name: "Wodonga", state: "VIC", postcode: "3690" },
    { name: "Wangaratta", state: "VIC", postcode: "3677" },
    { name: "Warrnambool", state: "VIC", postcode: "3280" },
    { name: "Traralgon", state: "VIC", postcode: "3844" },
    { name: "Carlton", state: "VIC", postcode: "3053" },
    { name: "Fitzroy", state: "VIC", postcode: "3065" },
    { name: "Richmond", state: "VIC", postcode: "3121" },
    { name: "Collingwood", state: "VIC", postcode: "3066" },
    { name: "South Yarra", state: "VIC", postcode: "3141" },
    { name: "Prahran", state: "VIC", postcode: "3181" },
    { name: "St Kilda", state: "VIC", postcode: "3182" },
    { name: "Brighton", state: "VIC", postcode: "3186" },
    { name: "Caulfield", state: "VIC", postcode: "3162" },
    { name: "Malvern", state: "VIC", postcode: "3144" },
    { name: "Armadale", state: "VIC", postcode: "3143" },
    { name: "Toorak", state: "VIC", postcode: "3142" },
    { name: "Hawthorn", state: "VIC", postcode: "3122" },
    { name: "Kew", state: "VIC", postcode: "3101" },
    { name: "Camberwell", state: "VIC", postcode: "3124" },
    { name: "Box Hill", state: "VIC", postcode: "3128" },
    { name: "Ringwood", state: "VIC", postcode: "3134" },
    { name: "Croydon", state: "VIC", postcode: "3136" },
    { name: "Mooroolbark", state: "VIC", postcode: "3138" },
    { name: "Lilydale", state: "VIC", postcode: "3140" },
    { name: "Belgrave", state: "VIC", postcode: "3160" },
    { name: "Ferntree Gully", state: "VIC", postcode: "3156" },
    { name: "Boronia", state: "VIC", postcode: "3155" },
    { name: "Glen Waverley", state: "VIC", postcode: "3150" },
    { name: "Mount Waverley", state: "VIC", postcode: "3149" },
    { name: "Oakleigh", state: "VIC", postcode: "3166" },
    { name: "Clayton", state: "VIC", postcode: "3168" },
    { name: "Monash", state: "VIC", postcode: "3168" },
    { name: "Springvale", state: "VIC", postcode: "3171" },
    { name: "Noble Park", state: "VIC", postcode: "3174" },
    { name: "Dandenong", state: "VIC", postcode: "3175" },
    { name: "Cranbourne", state: "VIC", postcode: "3977" },
    { name: "Frankston", state: "VIC", postcode: "3199" },
    { name: "Mornington", state: "VIC", postcode: "3931" },
    { name: "Rosebud", state: "VIC", postcode: "3939" },
    { name: "Rye", state: "VIC", postcode: "3941" },
    { name: "Sorrento", state: "VIC", postcode: "3943" },
    { name: "Portsea", state: "VIC", postcode: "3944" },
    { name: "Dromana", state: "VIC", postcode: "3936" },
    { name: "Mount Eliza", state: "VIC", postcode: "3930" },
    { name: "Chelsea", state: "VIC", postcode: "3196" },
    { name: "Edithvale", state: "VIC", postcode: "3196" },
    { name: "Aspendale", state: "VIC", postcode: "3195" },
    { name: "Mordialloc", state: "VIC", postcode: "3195" },
    { name: "Parkdale", state: "VIC", postcode: "3195" },
    { name: "Mentone", state: "VIC", postcode: "3194" },
    { name: "Cheltenham", state: "VIC", postcode: "3192" },
    { name: "Sandringham", state: "VIC", postcode: "3191" },
    { name: "Hampton", state: "VIC", postcode: "3188" },
    { name: "Beaumaris", state: "VIC", postcode: "3193" },
    { name: "Black Rock", state: "VIC", postcode: "3193" },
    { name: "Bentleigh", state: "VIC", postcode: "3204" },
    { name: "McKinnon", state: "VIC", postcode: "3204" },
    { name: "Ormond", state: "VIC", postcode: "3204" },
    { name: "Elsternwick", state: "VIC", postcode: "3185" },
    { name: "Elwood", state: "VIC", postcode: "3184" },
    { name: "Balaclava", state: "VIC", postcode: "3183" },
    { name: "Windsor", state: "VIC", postcode: "3181" },
    { name: "Port Melbourne", state: "VIC", postcode: "3207" },
    { name: "South Melbourne", state: "VIC", postcode: "3205" },
    { name: "Albert Park", state: "VIC", postcode: "3206" },
    { name: "Middle Park", state: "VIC", postcode: "3206" },
    { name: "Docklands", state: "VIC", postcode: "3008" },
    { name: "North Melbourne", state: "VIC", postcode: "3051" },
    { name: "Parkville", state: "VIC", postcode: "3052" },
    { name: "Brunswick", state: "VIC", postcode: "3056" },
    { name: "Coburg", state: "VIC", postcode: "3058" },
    { name: "Preston", state: "VIC", postcode: "3072" },
    { name: "Reservoir", state: "VIC", postcode: "3073" },
    { name: "Thornbury", state: "VIC", postcode: "3071" },
    { name: "Northcote", state: "VIC", postcode: "3070" },
    { name: "Fairfield", state: "VIC", postcode: "3078" },
    { name: "Heidelberg", state: "VIC", postcode: "3084" },
    { name: "Ivanhoe", state: "VIC", postcode: "3079" },
    { name: "Bulleen", state: "VIC", postcode: "3105" },
    { name: "Templestowe", state: "VIC", postcode: "3106" },
    { name: "Doncaster", state: "VIC", postcode: "3108" },
    { name: "Eltham", state: "VIC", postcode: "3095" },
    { name: "Diamond Creek", state: "VIC", postcode: "3089" },
    { name: "Greensborough", state: "VIC", postcode: "3088" },
    { name: "Bundoora", state: "VIC", postcode: "3083" },
    { name: "Mill Park", state: "VIC", postcode: "3082" },
    { name: "South Morang", state: "VIC", postcode: "3752" },
    { name: "Epping", state: "VIC", postcode: "3076" },
    { name: "Lalor", state: "VIC", postcode: "3075" },
    { name: "Thomastown", state: "VIC", postcode: "3074" },
    { name: "Broadmeadows", state: "VIC", postcode: "3047" },
    { name: "Craigieburn", state: "VIC", postcode: "3064" },
    { name: "Roxburgh Park", state: "VIC", postcode: "3064" },
    { name: "Sunbury", state: "VIC", postcode: "3429" },
    { name: "Melton", state: "VIC", postcode: "3337" },
    { name: "Caroline Springs", state: "VIC", postcode: "3023" },
    { name: "Werribee", state: "VIC", postcode: "3030" },
    { name: "Hoppers Crossing", state: "VIC", postcode: "3029" },
    { name: "Point Cook", state: "VIC", postcode: "3030" },
    { name: "Altona", state: "VIC", postcode: "3018" },
    { name: "Williamstown", state: "VIC", postcode: "3016" },
    { name: "Newport", state: "VIC", postcode: "3015" },
    { name: "Yarraville", state: "VIC", postcode: "3013" },
    { name: "Seddon", state: "VIC", postcode: "3011" },
    { name: "Footscray", state: "VIC", postcode: "3011" },
    { name: "Maribyrnong", state: "VIC", postcode: "3032" },
    { name: "Essendon", state: "VIC", postcode: "3040" },
    { name: "Moonee Ponds", state: "VIC", postcode: "3039" },
    { name: "Ascot Vale", state: "VIC", postcode: "3032" },
    { name: "Flemington", state: "VIC", postcode: "3031" },
    { name: "Kensington", state: "VIC", postcode: "3031" },
    { name: "Keilor", state: "VIC", postcode: "3036" },
    { name: "Airport West", state: "VIC", postcode: "3042" },
    { name: "Tullamarine", state: "VIC", postcode: "3043" },
    // Queensland (QLD)
    { name: "Brisbane", state: "QLD", postcode: "4000" },
    { name: "Gold Coast", state: "QLD", postcode: "4217" },
    { name: "Sunshine Coast", state: "QLD", postcode: "4558" },
    { name: "Townsville", state: "QLD", postcode: "4810" },
    { name: "Cairns", state: "QLD", postcode: "4870" },
    { name: "Toowoomba", state: "QLD", postcode: "4350" },
    { name: "Rockhampton", state: "QLD", postcode: "4700" },
    { name: "Mackay", state: "QLD", postcode: "4740" },
    { name: "Bundaberg", state: "QLD", postcode: "4670" },
    { name: "Hervey Bay", state: "QLD", postcode: "4655" },
    { name: "Gladstone", state: "QLD", postcode: "4680" },
    { name: "South Brisbane", state: "QLD", postcode: "4101" },
    { name: "Fortitude Valley", state: "QLD", postcode: "4006" },
    { name: "New Farm", state: "QLD", postcode: "4005" },
    { name: "Kangaroo Point", state: "QLD", postcode: "4169" },
    { name: "West End", state: "QLD", postcode: "4101" },
    { name: "Paddington", state: "QLD", postcode: "4064" },
    { name: "Red Hill", state: "QLD", postcode: "4059" },
    { name: "Toowong", state: "QLD", postcode: "4066" },
    { name: "Indooroopilly", state: "QLD", postcode: "4068" },
    { name: "St Lucia", state: "QLD", postcode: "4067" },
    { name: "Taringa", state: "QLD", postcode: "4068" },
    { name: "Kenmore", state: "QLD", postcode: "4069" },
    { name: "Chapel Hill", state: "QLD", postcode: "4069" },
    { name: "Fig Tree Pocket", state: "QLD", postcode: "4069" },
    { name: "Jindalee", state: "QLD", postcode: "4074" },
    { name: "Mount Ommaney", state: "QLD", postcode: "4074" },
    { name: "Oxley", state: "QLD", postcode: "4075" },
    { name: "Darra", state: "QLD", postcode: "4076" },
    { name: "Wacol", state: "QLD", postcode: "4076" },
    { name: "Richlands", state: "QLD", postcode: "4077" },
    { name: "Forest Lake", state: "QLD", postcode: "4078" },
    { name: "Inala", state: "QLD", postcode: "4077" },
    { name: "Acacia Ridge", state: "QLD", postcode: "4110" },
    { name: "Sunnybank", state: "QLD", postcode: "4109" },
    { name: "Sunnybank Hills", state: "QLD", postcode: "4109" },
    { name: "Macgregor", state: "QLD", postcode: "4109" },
    { name: "Robertson", state: "QLD", postcode: "4109" },
    { name: "Runcorn", state: "QLD", postcode: "4113" },
    { name: "Eight Mile Plains", state: "QLD", postcode: "4113" },
    { name: "Underwood", state: "QLD", postcode: "4119" },
    { name: "Springwood", state: "QLD", postcode: "4127" },
    { name: "Loganholme", state: "QLD", postcode: "4129" },
    { name: "Logan Central", state: "QLD", postcode: "4114" },
    { name: "Browns Plains", state: "QLD", postcode: "4118" },
    { name: "Beenleigh", state: "QLD", postcode: "4207" },
    { name: "Eagleby", state: "QLD", postcode: "4207" },
    { name: "Ormeau", state: "QLD", postcode: "4208" },
    { name: "Coomera", state: "QLD", postcode: "4209" },
    { name: "Pimpama", state: "QLD", postcode: "4209" },
    { name: "Upper Coomera", state: "QLD", postcode: "4209" },
    { name: "Oxenford", state: "QLD", postcode: "4210" },
    { name: "Helensvale", state: "QLD", postcode: "4212" },
    { name: "Hope Island", state: "QLD", postcode: "4212" },
    { name: "Sanctuary Cove", state: "QLD", postcode: "4212" },
    { name: "Southport", state: "QLD", postcode: "4215" },
    { name: "Surfers Paradise", state: "QLD", postcode: "4217" },
    { name: "Broadbeach", state: "QLD", postcode: "4218" },
    { name: "Mermaid Beach", state: "QLD", postcode: "4218" },
    { name: "Miami", state: "QLD", postcode: "4220" },
    { name: "Burleigh Heads", state: "QLD", postcode: "4220" },
    { name: "Palm Beach", state: "QLD", postcode: "4221" },
    { name: "Currumbin", state: "QLD", postcode: "4223" },
    { name: "Coolangatta", state: "QLD", postcode: "4225" },
    { name: "Nerang", state: "QLD", postcode: "4211" },
    { name: "Robina", state: "QLD", postcode: "4226" },
    { name: "Varsity Lakes", state: "QLD", postcode: "4227" },
    { name: "Mudgeeraba", state: "QLD", postcode: "4213" },
    { name: "Reedy Creek", state: "QLD", postcode: "4227" },
    { name: "Burleigh Waters", state: "QLD", postcode: "4220" },
    { name: "Ashmore", state: "QLD", postcode: "4214" },
    { name: "Molendinar", state: "QLD", postcode: "4214" },
    { name: "Arundel", state: "QLD", postcode: "4214" },
    { name: "Labrador", state: "QLD", postcode: "4215" },
    { name: "Parkwood", state: "QLD", postcode: "4214" },
    { name: "Biggera Waters", state: "QLD", postcode: "4216" },
    { name: "Runaway Bay", state: "QLD", postcode: "4216" },
    { name: "Coombabah", state: "QLD", postcode: "4216" },
    { name: "Cleveland", state: "QLD", postcode: "4163" },
    { name: "Redland Bay", state: "QLD", postcode: "4165" },
    { name: "Victoria Point", state: "QLD", postcode: "4165" },
    { name: "Wellington Point", state: "QLD", postcode: "4160" },
    { name: "Capalaba", state: "QLD", postcode: "4157" },
    { name: "Alexandra Hills", state: "QLD", postcode: "4161" },
    { name: "Thornlands", state: "QLD", postcode: "4164" },
    { name: "Wynnum", state: "QLD", postcode: "4178" },
    { name: "Manly", state: "QLD", postcode: "4179" },
    { name: "Lota", state: "QLD", postcode: "4179" },
    { name: "Tingalpa", state: "QLD", postcode: "4173" },
    { name: "Carina", state: "QLD", postcode: "4152" },
    { name: "Coorparoo", state: "QLD", postcode: "4151" },
    { name: "Camp Hill", state: "QLD", postcode: "4152" },
    { name: "Seven Hills", state: "QLD", postcode: "4170" },
    { name: "Morningside", state: "QLD", postcode: "4170" },
    { name: "Norman Park", state: "QLD", postcode: "4170" },
    { name: "Balmoral", state: "QLD", postcode: "4171" },
    { name: "Bulimba", state: "QLD", postcode: "4171" },
    { name: "Hawthorne", state: "QLD", postcode: "4171" },
    { name: "Woolloongabba", state: "QLD", postcode: "4102" },
    { name: "Greenslopes", state: "QLD", postcode: "4120" },
    { name: "Holland Park", state: "QLD", postcode: "4121" },
    { name: "Tarragindi", state: "QLD", postcode: "4121" },
    { name: "Mount Gravatt", state: "QLD", postcode: "4122" },
    { name: "Upper Mount Gravatt", state: "QLD", postcode: "4122" },
    { name: "Mansfield", state: "QLD", postcode: "4122" },
    { name: "Wishart", state: "QLD", postcode: "4122" },
    { name: "Rochedale", state: "QLD", postcode: "4123" },
    { name: "Chermside", state: "QLD", postcode: "4032" },
    { name: "Kedron", state: "QLD", postcode: "4031" },
    { name: "Nundah", state: "QLD", postcode: "4012" },
    { name: "Toombul", state: "QLD", postcode: "4012" },
    { name: "Wavell Heights", state: "QLD", postcode: "4012" },
    { name: "Clayfield", state: "QLD", postcode: "4011" },
    { name: "Ascot", state: "QLD", postcode: "4007" },
    { name: "Hamilton", state: "QLD", postcode: "4007" },
    { name: "Hendra", state: "QLD", postcode: "4011" },
    { name: "Northgate", state: "QLD", postcode: "4013" },
    { name: "Virginia", state: "QLD", postcode: "4014" },
    { name: "Boondall", state: "QLD", postcode: "4034" },
    { name: "Zillmere", state: "QLD", postcode: "4034" },
    { name: "Taigum", state: "QLD", postcode: "4018" },
    { name: "Bracken Ridge", state: "QLD", postcode: "4017" },
    { name: "Brighton", state: "QLD", postcode: "4017" },
    { name: "Sandgate", state: "QLD", postcode: "4017" },
    { name: "Shorncliffe", state: "QLD", postcode: "4017" },
    { name: "Deagon", state: "QLD", postcode: "4017" },
    { name: "Redcliffe", state: "QLD", postcode: "4020" },
    { name: "Scarborough", state: "QLD", postcode: "4020" },
    { name: "Margate", state: "QLD", postcode: "4019" },
    { name: "Woody Point", state: "QLD", postcode: "4019" },
    { name: "Clontarf", state: "QLD", postcode: "4019" },
    { name: "Kippa-Ring", state: "QLD", postcode: "4021" },
    { name: "Rothwell", state: "QLD", postcode: "4022" },
    { name: "Mango Hill", state: "QLD", postcode: "4509" },
    { name: "North Lakes", state: "QLD", postcode: "4509" },
    { name: "Kallangur", state: "QLD", postcode: "4503" },
    { name: "Dakabin", state: "QLD", postcode: "4503" },
    { name: "Petrie", state: "QLD", postcode: "4502" },
    { name: "Strathpine", state: "QLD", postcode: "4500" },
    { name: "Brendale", state: "QLD", postcode: "4500" },
    { name: "Lawnton", state: "QLD", postcode: "4501" },
    { name: "Albany Creek", state: "QLD", postcode: "4035" },
    { name: "Eatons Hill", state: "QLD", postcode: "4037" },
    { name: "Cashmere", state: "QLD", postcode: "4500" },
    { name: "Warner", state: "QLD", postcode: "4500" },
    { name: "Bray Park", state: "QLD", postcode: "4500" },
    { name: "Caboolture", state: "QLD", postcode: "4510" },
    { name: "Morayfield", state: "QLD", postcode: "4506" },
    { name: "Burpengary", state: "QLD", postcode: "4505" },
    { name: "Narangba", state: "QLD", postcode: "4504" },
    { name: "Caloundra", state: "QLD", postcode: "4551" },
    { name: "Maroochydore", state: "QLD", postcode: "4558" },
    { name: "Mooloolaba", state: "QLD", postcode: "4557" },
    { name: "Nambour", state: "QLD", postcode: "4560" },
    { name: "Noosa Heads", state: "QLD", postcode: "4567" },
    { name: "Noosaville", state: "QLD", postcode: "4566" },
    { name: "Tewantin", state: "QLD", postcode: "4565" },
    { name: "Buderim", state: "QLD", postcode: "4556" },
    { name: "Sippy Downs", state: "QLD", postcode: "4556" },
    { name: "Mountain Creek", state: "QLD", postcode: "4557" },
    { name: "Kawana", state: "QLD", postcode: "4558" },
    { name: "Buddina", state: "QLD", postcode: "4575" },
    { name: "Warana", state: "QLD", postcode: "4575" },
    { name: "Wurtulla", state: "QLD", postcode: "4575" },
    { name: "Bokarina", state: "QLD", postcode: "4575" },
    { name: "Currimundi", state: "QLD", postcode: "4551" },
    { name: "Pelican Waters", state: "QLD", postcode: "4551" },
    { name: "Golden Beach", state: "QLD", postcode: "4551" },
    // South Australia (SA)
    { name: "Adelaide", state: "SA", postcode: "5000" },
    { name: "Mount Gambier", state: "SA", postcode: "5290" },
    { name: "Whyalla", state: "SA", postcode: "5600" },
    { name: "Murray Bridge", state: "SA", postcode: "5253" },
    { name: "Port Lincoln", state: "SA", postcode: "5606" },
    { name: "Port Augusta", state: "SA", postcode: "5700" },
    { name: "Port Pirie", state: "SA", postcode: "5540" },
    { name: "Victor Harbor", state: "SA", postcode: "5211" },
    { name: "Gawler", state: "SA", postcode: "5118" },
    { name: "North Adelaide", state: "SA", postcode: "5006" },
    { name: "Unley", state: "SA", postcode: "5061" },
    { name: "Norwood", state: "SA", postcode: "5067" },
    { name: "Glenelg", state: "SA", postcode: "5045" },
    { name: "Brighton", state: "SA", postcode: "5048" },
    { name: "Marion", state: "SA", postcode: "5043" },
    { name: "Morphett Vale", state: "SA", postcode: "5162" },
    { name: "Noarlunga", state: "SA", postcode: "5168" },
    { name: "Aberfoyle Park", state: "SA", postcode: "5159" },
    { name: "Modbury", state: "SA", postcode: "5092" },
    { name: "Elizabeth", state: "SA", postcode: "5112" },
    { name: "Salisbury", state: "SA", postcode: "5108" },
    { name: "Prospect", state: "SA", postcode: "5082" },
    { name: "Campbelltown", state: "SA", postcode: "5074" },
    { name: "Paradise", state: "SA", postcode: "5075" },
    { name: "Athelstone", state: "SA", postcode: "5076" },
    { name: "Burnside", state: "SA", postcode: "5066" },
    { name: "Kensington", state: "SA", postcode: "5068" },
    { name: "Magill", state: "SA", postcode: "5072" },
    { name: "Henley Beach", state: "SA", postcode: "5022" },
    { name: "West Beach", state: "SA", postcode: "5024" },
    { name: "Seaton", state: "SA", postcode: "5023" },
    { name: "Woodville", state: "SA", postcode: "5011" },
    { name: "Port Adelaide", state: "SA", postcode: "5015" },
    { name: "Semaphore", state: "SA", postcode: "5019" },
    { name: "West Lakes", state: "SA", postcode: "5021" },
    { name: "Fulham", state: "SA", postcode: "5024" },
    { name: "Mawson Lakes", state: "SA", postcode: "5095" },
    { name: "Parafield Gardens", state: "SA", postcode: "5107" },
    { name: "Munno Para", state: "SA", postcode: "5115" },
    { name: "Smithfield", state: "SA", postcode: "5114" },
    { name: "Glenside", state: "SA", postcode: "5065" },
    { name: "Fullarton", state: "SA", postcode: "5063" },
    { name: "Hyde Park", state: "SA", postcode: "5061" },
    { name: "Goodwood", state: "SA", postcode: "5034" },
    { name: "Wayville", state: "SA", postcode: "5034" },
    { name: "Parkside", state: "SA", postcode: "5063" },
    // Western Australia (WA)
    { name: "Perth", state: "WA", postcode: "6000" },
    { name: "Mandurah", state: "WA", postcode: "6210" },
    { name: "Bunbury", state: "WA", postcode: "6230" },
    { name: "Albany", state: "WA", postcode: "6330" },
    { name: "Geraldton", state: "WA", postcode: "6530" },
    { name: "Kalgoorlie", state: "WA", postcode: "6430" },
    { name: "Busselton", state: "WA", postcode: "6280" },
    { name: "Broome", state: "WA", postcode: "6725" },
    { name: "Port Hedland", state: "WA", postcode: "6721" },
    { name: "Karratha", state: "WA", postcode: "6714" },
    { name: "Fremantle", state: "WA", postcode: "6160" },
    { name: "Joondalup", state: "WA", postcode: "6027" },
    { name: "Rockingham", state: "WA", postcode: "6168" },
    { name: "Armadale", state: "WA", postcode: "6112" },
    { name: "Subiaco", state: "WA", postcode: "6008" },
    { name: "Nedlands", state: "WA", postcode: "6009" },
    { name: "Cottesloe", state: "WA", postcode: "6011" },
    { name: "Claremont", state: "WA", postcode: "6010" },
    { name: "Scarborough", state: "WA", postcode: "6019" },
    { name: "Northbridge", state: "WA", postcode: "6003" },
    { name: "East Perth", state: "WA", postcode: "6004" },
    { name: "Victoria Park", state: "WA", postcode: "6100" },
    { name: "Cannington", state: "WA", postcode: "6107" },
    { name: "Midland", state: "WA", postcode: "6056" },
    { name: "Morley", state: "WA", postcode: "6062" },
    { name: "Belmont", state: "WA", postcode: "6104" },
    { name: "Kelmscott", state: "WA", postcode: "6111" },
    { name: "Gosnells", state: "WA", postcode: "6110" },
    { name: "Thornlie", state: "WA", postcode: "6108" },
    { name: "Canning Vale", state: "WA", postcode: "6155" },
    { name: "Baldivis", state: "WA", postcode: "6171" },
    { name: "Ellenbrook", state: "WA", postcode: "6069" },
    { name: "Stirling", state: "WA", postcode: "6021" },
    { name: "Osborne Park", state: "WA", postcode: "6017" },
    { name: "Malaga", state: "WA", postcode: "6090" },
    { name: "Wangara", state: "WA", postcode: "6065" },
    { name: "Butler", state: "WA", postcode: "6036" },
    { name: "Kinross", state: "WA", postcode: "6028" },
    { name: "Mindarie", state: "WA", postcode: "6030" },
    { name: "Hillarys", state: "WA", postcode: "6025" },
    { name: "Padbury", state: "WA", postcode: "6025" },
    { name: "Warwick", state: "WA", postcode: "6024" },
    { name: "Greenwood", state: "WA", postcode: "6024" },
    { name: "Duncraig", state: "WA", postcode: "6023" },
    { name: "Kallaroo", state: "WA", postcode: "6025" },
    { name: "Craigie", state: "WA", postcode: "6025" },
    { name: "Heathridge", state: "WA", postcode: "6027" },
    { name: "Mullaloo", state: "WA", postcode: "6027" },
    { name: "Melville", state: "WA", postcode: "6156" },
    { name: "Willetton", state: "WA", postcode: "6155" },
    { name: "Booragoon", state: "WA", postcode: "6154" },
    { name: "Bicton", state: "WA", postcode: "6157" },
    { name: "Applecross", state: "WA", postcode: "6153" },
    { name: "Como", state: "WA", postcode: "6152" },
    { name: "South Perth", state: "WA", postcode: "6151" },
    { name: "Riverton", state: "WA", postcode: "6148" },
    { name: "Shelley", state: "WA", postcode: "6148" },
    { name: "Rossmoyne", state: "WA", postcode: "6148" },
    { name: "Bull Creek", state: "WA", postcode: "6149" },
    { name: "Leeming", state: "WA", postcode: "6149" },
    { name: "Bateman", state: "WA", postcode: "6150" },
    { name: "Kardinya", state: "WA", postcode: "6163" },
    { name: "Winthrop", state: "WA", postcode: "6150" },
    { name: "Murdoch", state: "WA", postcode: "6150" },
    // Tasmania (TAS)
    { name: "Hobart", state: "TAS", postcode: "7000" },
    { name: "Launceston", state: "TAS", postcode: "7250" },
    { name: "Devonport", state: "TAS", postcode: "7310" },
    { name: "Burnie", state: "TAS", postcode: "7320" },
    { name: "Kingston", state: "TAS", postcode: "7050" },
    { name: "Ulverstone", state: "TAS", postcode: "7315" },
    { name: "Glenorchy", state: "TAS", postcode: "7010" },
    { name: "Bridgewater", state: "TAS", postcode: "7030" },
    { name: "Sorell", state: "TAS", postcode: "7172" },
    { name: "New Norfolk", state: "TAS", postcode: "7140" },
    { name: "Bellerive", state: "TAS", postcode: "7018" },
    { name: "Rosny", state: "TAS", postcode: "7018" },
    { name: "Lindisfarne", state: "TAS", postcode: "7015" },
    { name: "Howrah", state: "TAS", postcode: "7018" },
    { name: "Clarence", state: "TAS", postcode: "7170" },
    { name: "Sandy Bay", state: "TAS", postcode: "7005" },
    { name: "Battery Point", state: "TAS", postcode: "7004" },
    { name: "Mount Nelson", state: "TAS", postcode: "7007" },
    { name: "South Hobart", state: "TAS", postcode: "7004" },
    { name: "West Hobart", state: "TAS", postcode: "7000" },
    { name: "North Hobart", state: "TAS", postcode: "7000" },
    { name: "Moonah", state: "TAS", postcode: "7009" },
    { name: "Claremont", state: "TAS", postcode: "7011" },
    { name: "Lenah Valley", state: "TAS", postcode: "7008" },
    { name: "Mount Stuart", state: "TAS", postcode: "7000" },
    { name: "Goodwood", state: "TAS", postcode: "7010" },
    { name: "Blackmans Bay", state: "TAS", postcode: "7052" },
    { name: "Snug", state: "TAS", postcode: "7054" },
    { name: "Huonville", state: "TAS", postcode: "7109" },
    // Australian Capital Territory (ACT)
    { name: "Canberra", state: "ACT", postcode: "2600" },
    { name: "Belconnen", state: "ACT", postcode: "2617" },
    { name: "Gungahlin", state: "ACT", postcode: "2912" },
    { name: "Woden", state: "ACT", postcode: "2606" },
    { name: "Tuggeranong", state: "ACT", postcode: "2900" },
    { name: "Civic", state: "ACT", postcode: "2601" },
    { name: "Kingston", state: "ACT", postcode: "2604" },
    { name: "Barton", state: "ACT", postcode: "2600" },
    { name: "Manuka", state: "ACT", postcode: "2603" },
    { name: "Braddon", state: "ACT", postcode: "2612" },
    { name: "Turner", state: "ACT", postcode: "2612" },
    { name: "Dickson", state: "ACT", postcode: "2602" },
    { name: "Lyneham", state: "ACT", postcode: "2602" },
    { name: "O'Connor", state: "ACT", postcode: "2602" },
    { name: "Acton", state: "ACT", postcode: "2601" },
    { name: "Griffith", state: "ACT", postcode: "2603" },
    { name: "Red Hill", state: "ACT", postcode: "2603" },
    { name: "Narrabundah", state: "ACT", postcode: "2604" },
    { name: "Deakin", state: "ACT", postcode: "2600" },
    { name: "Yarralumla", state: "ACT", postcode: "2600" },
    { name: "Curtin", state: "ACT", postcode: "2605" },
    { name: "Hughes", state: "ACT", postcode: "2605" },
    { name: "Garran", state: "ACT", postcode: "2605" },
    { name: "Phillip", state: "ACT", postcode: "2606" },
    { name: "Pearce", state: "ACT", postcode: "2607" },
    { name: "Torrens", state: "ACT", postcode: "2607" },
    { name: "Chifley", state: "ACT", postcode: "2606" },
    { name: "Isaacs", state: "ACT", postcode: "2607" },
    { name: "Mawson", state: "ACT", postcode: "2607" },
    { name: "Farrer", state: "ACT", postcode: "2607" },
    { name: "Kambah", state: "ACT", postcode: "2902" },
    { name: "Wanniassa", state: "ACT", postcode: "2903" },
    { name: "Erindale", state: "ACT", postcode: "2903" },
    { name: "Fadden", state: "ACT", postcode: "2904" },
    { name: "Gowrie", state: "ACT", postcode: "2904" },
    { name: "Monash", state: "ACT", postcode: "2904" },
    { name: "Oxley", state: "ACT", postcode: "2903" },
    { name: "Richardson", state: "ACT", postcode: "2905" },
    { name: "Calwell", state: "ACT", postcode: "2905" },
    { name: "Theodore", state: "ACT", postcode: "2905" },
    { name: "Conder", state: "ACT", postcode: "2906" },
    { name: "Gordon", state: "ACT", postcode: "2906" },
    { name: "Banks", state: "ACT", postcode: "2906" },
    { name: "Chisholm", state: "ACT", postcode: "2905" },
    { name: "Gilmore", state: "ACT", postcode: "2905" },
    { name: "Macarthur", state: "ACT", postcode: "2904" },
    { name: "Page", state: "ACT", postcode: "2614" },
    { name: "Weetangera", state: "ACT", postcode: "2614" },
    { name: "Scullin", state: "ACT", postcode: "2614" },
    { name: "Florey", state: "ACT", postcode: "2615" },
    { name: "Latham", state: "ACT", postcode: "2615" },
    { name: "Higgins", state: "ACT", postcode: "2615" },
    { name: "Holt", state: "ACT", postcode: "2615" },
    { name: "Macquarie", state: "ACT", postcode: "2614" },
    { name: "Kaleen", state: "ACT", postcode: "2617" },
    { name: "Giralang", state: "ACT", postcode: "2617" },
    { name: "Bruce", state: "ACT", postcode: "2617" },
    { name: "McKellar", state: "ACT", postcode: "2617" },
    { name: "Evatt", state: "ACT", postcode: "2617" },
    { name: "Spence", state: "ACT", postcode: "2615" },
    { name: "Melba", state: "ACT", postcode: "2615" },
    { name: "Charnwood", state: "ACT", postcode: "2615" },
    { name: "Dunlop", state: "ACT", postcode: "2615" },
    { name: "Macgregor", state: "ACT", postcode: "2615" },
    { name: "Fraser", state: "ACT", postcode: "2615" },
    { name: "Palmerston", state: "ACT", postcode: "2913" },
    { name: "Mitchell", state: "ACT", postcode: "2911" },
    { name: "Harrison", state: "ACT", postcode: "2914" },
    { name: "Franklin", state: "ACT", postcode: "2913" },
    { name: "Amaroo", state: "ACT", postcode: "2914" },
    { name: "Ngunnawal", state: "ACT", postcode: "2913" },
    { name: "Nicholls", state: "ACT", postcode: "2913" },
    { name: "Casey", state: "ACT", postcode: "2913" },
    { name: "Forde", state: "ACT", postcode: "2914" },
    { name: "Bonner", state: "ACT", postcode: "2914" },
    { name: "Crace", state: "ACT", postcode: "2911" },
    { name: "Moncrieff", state: "ACT", postcode: "2914" },
    { name: "Jacka", state: "ACT", postcode: "2914" },
    { name: "Taylor", state: "ACT", postcode: "2913" },
    // Northern Territory (NT)
    { name: "Darwin", state: "NT", postcode: "0800" },
    { name: "Alice Springs", state: "NT", postcode: "0870" },
    { name: "Palmerston", state: "NT", postcode: "0830" },
    { name: "Casuarina", state: "NT", postcode: "0810" },
    { name: "Nightcliff", state: "NT", postcode: "0810" },
    { name: "Rapid Creek", state: "NT", postcode: "0810" },
    { name: "Millner", state: "NT", postcode: "0810" },
    { name: "Coconut Grove", state: "NT", postcode: "0810" },
    { name: "Fannie Bay", state: "NT", postcode: "0820" },
    { name: "Stuart Park", state: "NT", postcode: "0820" },
    { name: "Parap", state: "NT", postcode: "0820" },
    { name: "Woolner", state: "NT", postcode: "0820" },
    { name: "The Gardens", state: "NT", postcode: "0820" },
    { name: "Larrakeyah", state: "NT", postcode: "0820" },
    { name: "The Narrows", state: "NT", postcode: "0820" },
    { name: "Bayview", state: "NT", postcode: "0820" },
    { name: "Berrimah", state: "NT", postcode: "0828" },
    { name: "Winnellie", state: "NT", postcode: "0820" },
    { name: "Marrara", state: "NT", postcode: "0812" },
    { name: "Wulagi", state: "NT", postcode: "0812" },
    { name: "Karama", state: "NT", postcode: "0812" },
    { name: "Moulden", state: "NT", postcode: "0830" },
    { name: "Gray", state: "NT", postcode: "0830" },
    { name: "Durack", state: "NT", postcode: "0830" },
    { name: "Rosebery", state: "NT", postcode: "0832" },
    { name: "Woodroffe", state: "NT", postcode: "0830" },
    { name: "Gunn", state: "NT", postcode: "0832" },
    { name: "Driver", state: "NT", postcode: "0830" },
    { name: "Yarrawonga", state: "NT", postcode: "0830" },
    { name: "Zuccoli", state: "NT", postcode: "0832" },
    { name: "Johnston", state: "NT", postcode: "0832" },
    { name: "Bellamack", state: "NT", postcode: "0832" },
    { name: "Lyons", state: "NT", postcode: "0810" },
    { name: "Anula", state: "NT", postcode: "0812" },
    { name: "Jingili", state: "NT", postcode: "0810" },
    { name: "Moil", state: "NT", postcode: "0810" },
    { name: "Leanyer", state: "NT", postcode: "0812" },
    { name: "Nakara", state: "NT", postcode: "0810" },
    { name: "Tiwi", state: "NT", postcode: "0810" },
    { name: "Wanguri", state: "NT", postcode: "0810" },
    { name: "Alawa", state: "NT", postcode: "0810" },
];
const MATTHEW_PROCTOR_JSON_URL = "https://raw.githubusercontent.com/matthewproctor/australianpostcodes/master/australian_postcodes.json";
/** Session cache for Matthew Proctor data - fetched once, reused for all subsequent searches */
let matthewProctorCache = null;
/** Fetches Matthew Proctor postcode data, maps to SuburbData, dedupes, and caches */
async function fetchMatthewProctorSuburbs() {
    if (matthewProctorCache)
        return matthewProctorCache;
    const response = await fetch(MATTHEW_PROCTOR_JSON_URL);
    if (!response.ok)
        throw new Error(`Failed to fetch postcodes: ${response.status}`);
    const raw = await response.json();
    const seen = new Set();
    const suburbs = [];
    for (const entry of raw) {
        const locality = (entry.locality ?? "").trim();
        const state = (entry.state ?? "").trim();
        const postcode = String(entry.postcode ?? "").trim();
        if (!locality || !state || !postcode)
            continue;
        const key = `${locality}|${state}|${postcode}`;
        if (seen.has(key))
            continue;
        seen.add(key);
        suburbs.push({ name: locality, state, postcode });
    }
    matthewProctorCache = suburbs;
    return suburbs;
}
function searchInSuburbs(suburbs, searchTerm) {
    return suburbs.filter((suburb) => suburb.name.toLowerCase().includes(searchTerm) ||
        suburb.state.toLowerCase().includes(searchTerm) ||
        suburb.postcode.includes(searchTerm));
}
/** Async suburb search: AUSTRALIAN_SUBURBS first, then Matthew Proctor (cached per session) */
export async function searchSuburbsAsync(query) {
    const searchTerm = query.toLowerCase().trim();
    if (!searchTerm)
        return AUSTRALIAN_SUBURBS;
    const localResults = searchInSuburbs(AUSTRALIAN_SUBURBS, searchTerm);
    if (localResults.length > 0)
        return localResults;
    const mpSuburbs = await fetchMatthewProctorSuburbs();
    return searchInSuburbs(mpSuburbs, searchTerm);
}
// Helper function to get all unique suburbs (just the names)
export const getAllSuburbNames = () => {
    return Array.from(new Set(AUSTRALIAN_SUBURBS.map(s => s.name))).sort();
};
// Helper function to search suburbs (sync, local list only)
export const searchSuburbs = (query) => {
    const searchTerm = query.toLowerCase().trim();
    if (!searchTerm)
        return AUSTRALIAN_SUBURBS;
    return searchInSuburbs(AUSTRALIAN_SUBURBS, searchTerm);
};
// Helper function to get suburbs by state
export const getSuburbsByState = (state) => {
    return AUSTRALIAN_SUBURBS.filter(suburb => suburb.state === state);
};
// Australian states/territories
export const AUSTRALIAN_STATES = [
    { code: "NSW", name: "New South Wales" },
    { code: "VIC", name: "Victoria" },
    { code: "QLD", name: "Queensland" },
    { code: "SA", name: "South Australia" },
    { code: "WA", name: "Western Australia" },
    { code: "TAS", name: "Tasmania" },
    { code: "ACT", name: "Australian Capital Territory" },
    { code: "NT", name: "Northern Territory" },
];
